import Vue from "vue";
import yz from "./yz";
import http from '@/axios/http.js'

import { upLoadFile } from "@/api/common";
import { shrinkage_identity } from "@/api/apply";

const install = {
	// 将json转为get参数
	getParamByJson (json) {
		return Object.keys(json).map(function (key) {
			return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
		}).join("&");
	},


	// 下载文件 
	downloadFile (data, fileName, contentType) {
		const blob = new Blob([data], { type: contentType });
		const url = URL.createObjectURL(blob);

		const a = document.createElement('a');
		a.href = url;
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);

		// 使用方式
		// downloadFile(downRes, fileName, 'application/zip')
		// downloadFile(downRes,fileName,'text/plain')
	},

	// 时间戳转星期
	timestampToWeekday (timestamp) {
		const date = new Date(timestamp);
		const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
		return days[date.getDay()];
		// 示例用法
		// const timestamp = 1686387200000; // 替换为实际的时间戳
		// const weekday = timestampToWeekday(timestamp);
		// console.log(weekday);
	},

	// 时间戳转年月日 (补0)
	timestampToYMD (timestamp) {
		const date = new Date(timestamp);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
		// 示例用法
		// const timestamp = 1686387200000; // 替换为实际的时间戳
		// const result = timestampToYMD(timestamp);
		// console.log(result);
	},





	// 获取字典数据
	async getDictionary (type) {
		return await http.get('/stage-api/pre/dict/type/' + type)
	},


	// 获取当前登录用户信息
	async getUserInfo () {
		return await shrinkage_identity();
	},
	// 上传文件
	async upLoadFile (params, data) {
		return await upLoadFile(params, data);
	},

	// file 文件转Blob
	fileToBolb (file) {
		const blob = new Blob([file], { type: file.type });
		const blobUrl = URL.createObjectURL(blob);
		return blobUrl;
	},

	toast (font) {
		Vue.$alert(font, "提示", {
			confirmButtonText: "确定",
			showClose: false,
		});
	},

	getUrlParam (name) {
		const params = new URLSearchParams(window.location.href.split('?')[1]);
		return params.get(name);
	},
	

	yz,

	queryZhibiao (lotteryType, indexType) {
		if (lotteryType == 1) {
			return indexType == 1
				? "80-89.9万"
				: indexType == 2
					? "50-59.9万"
					: indexType == 3
						? "15-21.9万"
						: indexType == 4
							? "4-9.9万"
							: indexType == 5
								? "5005注以下"
								: indexType == 6
									? "杀6蓝"
									: indexType == 7
										? "围4蓝"
										: "";
		}
		if (lotteryType == 2) {
			return indexType == 1
				? "24-26.9万"
				: indexType == 2
					? "15-17.9万"
					: indexType == 3
						? "3-5.9万"
						: indexType == 4
							? "1-1.9万"
							: indexType == 5
								? "4368注以下"
								: indexType == 6
									? "杀5后"
									: indexType == 7
										? "围3后"
										: "";
		}
		if ([3, 4].includes(lotteryType)) {
			return indexType == 1
				? "700-799注"
				: indexType == 2
					? "400-599注"
					: indexType == 3
						? "200-399注"
						: indexType == 4
							? "50-199注"
							: indexType == 5
								? "1-49注"
								: "";
		}
	},



};

export default install;


